<template>
  <div class="animated fadeIn">
    <div class="card card-green">
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-sm-2">
            <label class="custom-label">{{ $t('GROUPS') }}</label>
            <select class="form-control" v-model="selectedGroup">
              <option value="">{{ $t('ALL') }}</option>
              <option v-for="item in group.root" :key="item.workingGroupId" :value="item.workingGroupId">
                {{ item.name }}</option>
            </select>
          </div>
          <div class="col-sm-2">
            <button type="button" class="btn btn-primary button-add pull-right" @click="showModal()">{{ $t('NEW')
            }}</button>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12  table-responsive">
            <table class="table table-bordered table-striped table-hover table-sm table-logoped">
              <thead>
                <tr>
                  <th>
                    {{ $t('ORDERNUM') }}
                  </th>
                  <th>
                    {{ $t('NAME') }}
                  </th>
                  <th>
                    {{ $t('BIRTHDATE') }}
                  </th>
                  <th>
                    {{ $t('PHONENUMBER') }}
                  </th>
                  <th>
                    {{ $t('GROUP') }}
                  </th>
                  <th>
                    {{ $t('DATEOFCONTACT') }}
                  </th>
                  <th>
                    {{ $t('NOTE') }}
                  </th>
                  <th>{{ $t('ACTION') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, key) in response.root" :key="item.groupWaitingListId" aria-rowindex="1"
                  class=" table-ellipsis">
                  <td>{{ ( ((pagination.currentPage - 1) * pagination.limit) + key + 1) }}</td>
                  <td>{{ item.name }} {{ item.surname }}</td>
                  <td>{{ moment.utc(item.birthDate).local().format('DD.MM.YYYY') }}</td>
                  <td>{{ item.phoneNumber }}</td>
                  <td>{{ item.workingGroupName }}</td>
                  <td>{{ moment.utc(item.dateOfContact).local().format('DD.MM.YYYY') }}</td>
                  <td>{{ item.description }}</td>
                  <td>
                    <button type="button" class="btn button-edit mr-2" v-if="item.childId == null"
                      @click="approve(item)">{{ $t('APPROVED')
                      }}</button>
                    <button type="button" class="btn button-edit mr-2" @click="showModal(item)">{{ $t('EDIT') }}</button>
                    <button type="button" class="btn button-dlt" @click="deleteRow(item.groupWaitingListId)">{{
                      $t('DELETE') }}</button>
                  </td>
                </tr>
              </tbody>
            </table>
            <nav>
              <pagination v-bind:totalCount="response.totalCount" v-model="pagination" v-on:reload="getData">
              </pagination>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <GroupWaitingListForm v-model="formData" v-on:close="formData = null; getData()"></GroupWaitingListForm>
  </div>
</template>

<script>
import moment from 'moment';
import Api from '@/api/group_waiting_list/GroupWaitingList';
import ChildApi from '@/api/child/Child';
import GroupApi from '@/api/working_group/WorkingGroup';
import GroupWaitingListForm from './Form.vue';

export default
  {
    name: 'GroupWaitingList',
    components:
    {
      GroupWaitingListForm,
    },
    data() {
      return {
        group: {},
        selectedGroup: '',
        response:
          {},
        formError:
          {},
        formData: null,
        pagination:
        {
          query: '',
          currentPage: 1,
          limit: 25,
          searchTimeout: false,
        },
        workingGroupPagination:
        {
          query: '',
          currentPage: 1,
          limit: 25,
          searchTimeout: false,
        },
      };
    },
    created() {
      const me = this;
      me.getData();
      me.getWorkingGroupData();
    },
    methods:
    {
      async getWorkingGroupData() {
        const me = this;
        try {
          const data = await GroupApi.selectRow(me.getParamsWorkingGroups);
          if (data.error && data.error === true) {
            me.$notify.notice(data);
            me.loading = false;
            return;
          }

          me.group = data;
        }
        catch (e) {
          me.$notify.notice(e);
        }
      },
      async getData() {
        const me = this;
        try {
          const data = await Api.selectRow(me.getParams);
          if (data.error && data.error === true) {
            me.$notify.notice(data);
            me.loading = false;
            return;
          }

          me.response = data;
        }
        catch (e) {
          me.$notify.notice(e);
        }
      },

      async deleteRow(id) {
        const me = this;
        try {
          me.$store.commit('setModalAlert',
            {
              text: me.$i18n.t('AREYOUSHURE'),
              async btnAction() {
                const data = await Api.deleteRow(
                  {
                    id,
                  },
                );
                me.$notify.notice(data);
                await me.getData();
              },
            });
        }
        catch (e) {
          me.$notify.notice(e);
        }
      },
      async approve(item) {
        const me = this;
        try {
          const params = {
            name: item.name,
            surname: item.surname,
            groupId: item.groupId,
            birthDate: moment(item.birthDate).format('YYYY-MM-DD')
          }

          const data = await ChildApi.submitData(item);
          if (data.error) {
            me.$notify.notice(data);
          }
          else {

            const waitinListParams = {
              id: item.groupWaitingListId,
              childId: data.lastId,
            };

            await Api.submitData(waitinListParams);

            const groupParams = {
              childId: data.lastId,
              selected: 1,
              workingGroupId: item.groupId
            };

            const dataGroupResponse = await GroupApi.upsertChild(groupParams);
            me.$notify.notice(dataGroupResponse);
            await me.getData();
          }
        }
        catch (e) {
          me.$notify.notice(e);
        }
      },
      showModal(item) {
        const me = this;
        let data = {};
        if (typeof item !== 'undefined') {
          data = { ...item };
        }

        me.formData = data;
      },
    },
    watch:
    {
      selectedGroup() {
        const me = this;
        me.getData();
      },
      'pagination.limit'() {
        const me = this;
        me.getData();
      },
      'pagination.currentPage'() {
        const me = this;
        me.getData();
      },
      'pagination.query'() {
        const me = this;

        if (me.pagination.searchTimeout !== false) {
          clearTimeout(me.pagination.searchTimeout);
        }

        me.pagination.searchTimeout = setTimeout(() => {
          me.getData();
          me.pagination.searchTimeout = false;
        }, 300);
      },
    },
    computed:
    {
      getParams() {
        const me = this;
        const data = {
          ...me.pagination,
        };
        data.groupId = me.selectedGroup;
        data.start = (data.currentPage - 1) * data.limit;
        return data;
      },
      getParamsWorkingGroups() {
        const me = this;
        const data = {
          ...me.workingGroupPagination,
        };
        data.start = (data.currentPage - 1) * data.limit;
        return data;
      },
    },
  };
</script>
